import { ItemsWrapper } from './styles';

export const Items = ({ text, info }) => (
  <ItemsWrapper>
    <strong>{text}</strong>
    {info}
  </ItemsWrapper>
);
